// Sync these breakpoints with their SASS analogues in global_styles.
export const breakpoints = {
  inflateLayoutBreakpoint: 960,
  stackSignUpBreakpoint: 920,
  hideNavigationBreakpoint: 750,
  deflateLayoutBreakpoint: 420,
};



// WEBPACK FOOTER //
// ./services/layout/breakpoints.js